import reducerWithFlags from 'shared/lib/reducerWithFlags';
import { DEFAULT_LANGUAGE_CODE, DEFAULT_CURRENCY } from 'shared/constants';
import { PROFILE_UPDATED, PROFILE_PARSE_SUCCESS } from './profile';

export const AUTH_LOGIN = 'AUTH_LOGIN';
export const AUTH_LOGIN_NEEDED = 'AUTH_LOGIN_NEEDED';
export const AUTH_LOGIN_IN_PROGRESS = 'AUTH_LOGIN_IN_PROGRESS';
export const AUTH_LOGIN_SUCCEEDED = 'AUTH_LOGIN_SUCCEEDED';
export const AUTH_SIGNUP_SUCCEEDED = 'AUTH_SIGNUP_SUCCEEDED';
export const AUTH_LOGIN_FAILED = 'AUTH_LOGIN_FAILED';
export const AUTH_LOGOUT = 'AUTH_LOGOUT';
export const AUTH_FORCE_LOGOUT = 'AUTH_FORCE_LOGOUT';
export const AUTH_STATE_RESTORED = 'AUTH_STATE_RESTORED';
const AUTH_USER_UPDATE = 'AUTH_USER_UPDATE';
const AUTH_USER_UPDATING = 'AUTH_USER_UPDATING';
export const AUTH_USER_UPDATED = 'AUTH_USER_UPDATED';
const AUTH_USER_UPDATE_FAILED = 'AUTH_USER_UPDATE_FAILED';
export const AUTH_ALREADY_LOGGED_OUT = 'AUTH_ALREADY_LOGGED_OUT';
export const AUTH_SET_LANGUAGE = 'AUTH_SET_LANGUAGE';
export const AUTH_SET_CURRENCY = 'AUTH_SET_CURRENCY';

const initialState = {
  loggingIn: false,
  loggingOut: false,
  loggedIn: false,
  loggedOut: null,
  user: {},
  token: null,
  error: null,
  language: localStorage.getItem('i18nextLng') || DEFAULT_LANGUAGE_CODE
};

export default reducerWithFlags((state = initialState, action) => {
  switch (action.type) {
    case AUTH_LOGIN_IN_PROGRESS:
      return { ...initialState, loggingIn: true };
    case AUTH_LOGIN_SUCCEEDED:
    case AUTH_SIGNUP_SUCCEEDED:
      return {
        ...initialState,
        loggingIn: false,
        loggedIn: true,
        error: null,
        signup: action.type === AUTH_SIGNUP_SUCCEEDED,
        ...action.result,
        language: action.result.user.language || state.language
      };
    case AUTH_LOGIN_FAILED:
      return { ...initialState, error: action.error };
    case AUTH_LOGOUT:
    case AUTH_FORCE_LOGOUT:
      return { ...initialState, language: state.language };
    case AUTH_USER_UPDATED:
    case PROFILE_UPDATED: {
      const { firstname, lastname, language, photo, gender } = action.result;
      return { ...state, user: { ...state.user, firstname, lastname, language, photo, gender } };
    }
    case PROFILE_PARSE_SUCCESS: {
      if (action.payload.result.photo) {
        return { ...state, user: { ...state.user, photo: action.payload.result.photo } };
      }
      return state;
    }
    case AUTH_SET_LANGUAGE: {
      return { ...state, language: action.payload };
    }
    case AUTH_SET_CURRENCY: {
      return {
        ...state,
        user: {
          ...state.user,
          currency: action.payload
        }
      };
    }
    default:
      return state;
  }
},
[/* no loading actions */],
[AUTH_USER_UPDATING],
'AUTH_');

export const selectors = {
  isLoggedIn(state) {
    return state.auth.loggedIn;
  },
  getState(state) {
    return state.auth;
  },
  getUser(state) {
    return state.auth.user;
  },
  getLanguage(state) {
    return state.auth.language;
  },
  isImpersonified(state) {
    return state.auth.impersonification;
  },
  getUserCurrency(state) {
    return state.auth.loggedIn ? state.auth.user.currency : DEFAULT_CURRENCY;
  },
  getFlags(state) {
    return {
      loggingIn: state.auth.loggingIn,
      loggingOut: state.auth.loggingOut,
    };
  }
};

export const actions = {
  login(credentials = {}) {
    return {
      type: AUTH_LOGIN,
      types: [AUTH_LOGIN_IN_PROGRESS, AUTH_LOGIN_SUCCEEDED, AUTH_LOGIN_FAILED],
      callApi: client => client.post('/auth/login', credentials)
    };
  },
  loginSucceeded(payload) {
    return {
      type: AUTH_LOGIN_SUCCEEDED,
      result: payload
    };
  },
  loginAfterSignup(data) {
    return {
      type: AUTH_SIGNUP_SUCCEEDED,
      result: data
    };
  },
  loginNeeded() {
    return {
      type: AUTH_LOGIN_NEEDED
    };
  },
  logout() {
    return {
      type: AUTH_LOGOUT
    };
  },
  forceLogout() {
    return {
      type: AUTH_FORCE_LOGOUT
    };
  },
  authRestored(payload) {
    return {
      type: AUTH_STATE_RESTORED,
      payload
    };
  },
  updateUser(payload) {
    return {
      type: AUTH_USER_UPDATE,
      types: [AUTH_USER_UPDATING, AUTH_USER_UPDATED, AUTH_USER_UPDATE_FAILED],
      callApi: client => client.post('/user/profile', payload)
    };
  },
  updatePhoto(photo, onSuccess, onFailure) {
    photo.lastModifiedDate = new Date();
    photo.name = 'photo.png';

    return {
      type: AUTH_USER_UPDATE,
      types: [AUTH_USER_UPDATING, AUTH_USER_UPDATED, AUTH_USER_UPDATE_FAILED],
      callApi: client => client.post('/user/photo', {}, {}, [{ name: 'photo', file: photo }]),
      onSuccess: onSuccess ? [onSuccess] : [],
      onFailure: onFailure ? [onFailure] : []
    };
  },
  setLanguage(language) {
    return {
      type: AUTH_SET_LANGUAGE,
      payload: language
    };
  },
  setCurrency(currency) {
    return {
      type: AUTH_SET_CURRENCY,
      payload: currency
    };
  }
};
